//@ts-nocheck
import { routingMixin } from "@jack-henry/web-component-router";
import Router from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "@banno/jha-wc/src/jha-tab/jha-tab";
import "@banno/jha-wc/src/jha-tab-item/jha-tab-item";
import "../EditUser/UserInfo";
import "../EditUser/UserAuthentication";
import { Apis } from "../../../utils/api-constants";
import { fixedEncodeURIComponent, getRequest, putRequest } from "../../../utils/jha-fetch";
import { AddUserType } from "../../../types/Users/AddUserType";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { GlobalVariables } from "../../../utils/constants";
import { routerConfig } from "../../../routers";
import { AppRouters } from "../../../utils/app-router";
import { stringComparison } from "../../../utils/app-utils";
import "@banno/jha-wc/src/cards/jha-card/jha-card";

@customElement("edit-user-tab")
export class EditUserTabView extends routingMixin(LitElement) {
  constructor() {
    super();
  }

  @state() private hasUnsavedChanges = false;

  @property()
  activeTab = "page1";

  @property({ type: Boolean })
  isEditable = false;

  @property({ reflect: true, attribute: "user-id" })
  userId = "";
  @property()
  userDetails = {};
  @property({ type: Boolean })
  apiLoading = false;
  static get is() {
    return "edit-user-tab";
  }
  static readonly styles = css`
    #editUserTab {
      padding: 24px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    jha-card {
      padding: 24px;
      flex: 1;
      margin-left: 0px;
      margin-right: 0px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    #tabContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: auto;
    }
    user-info {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    user-auth {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    #editUserTitle {
      color: #085ce5;
    }
    #backBtn {
      cursor: pointer;
      margin-right: 10px;
    }
  `;
  async connectedCallback() {
    super.connectedCallback();
    this.addEventListener("unsaved-changes", this.onUnsavedChanges);
    const getUserData = await getRequest(Apis.GET_USER + `/${this.userId}`);
    this.userDetails = {
      ...getUserData,
      role: /readonly/i.test(getUserData?.role) ? "ReadOnly" : "ReadWrite",
    };
  }

  disconnectedCallback() {
    this.removeEventListener("unsaved-changes", this.onUnsavedChanges);
    super.disconnectedCallback();
  }

  private onUnsavedChanges(event: CustomEvent) {
    this.hasUnsavedChanges = event.detail.hasUnsavedChanges;
  }
  private beforeUnloadHandler(event: BeforeUnloadEvent) {
    if (this.hasUnsavedChanges) {
      event.preventDefault();
      event.returnValue = "";
    }
  }

  // Unsaved Stay/Leave is on user-info / user-auth onCancelClick (no throw). Do not
  // re-enable this by throwing from a shell handler — Stay is a normal outcome.
  // async routeExit(currentNode, nextNode, routeId, context) {  // commented because its effecting Cancel func
  //   const userInfoForm = this.shadowRoot.querySelector('user-info');
  //   const userAuthForm = this.shadowRoot.querySelector('user-auth');
  //   if ((userInfoForm && userInfoForm.formDirty) || (userAuthForm && userAuthForm.hasUnsavedChanges)) {
  //     try{
  //       await this.onCancelClick();
  //       const router = new Router(routerConfig);
  //       router.go(context.path);
  //       return;
  //     } catch (error) {
  //       console.log(error);
  //       history.pushState(null, '', location.href);
  //       history.back();
  //       return;
  //     }
  //   }
  //   const router = new Router(routerConfig);
  //   router.go(context.path);
  // }

  async onSaveInfoChangesClick(e) {
    this.apiLoading = true;
    const router = new Router(routerConfig);
    const params = {
      email: e.detail.email,
      homeDirectory: e.detail.homeDirectory,
      role: e.detail.role,
      userType: e.detail.userType,
      businessUnit: e.detail.businessUnit,
      fullName: e.detail.fullName,
      note: e.detail.note,
      userProfileType: e.detail.userProfileType,
      status: this.userDetails.status,
      authType: e.detail.authType,
    };
    params.homeDirectory =
      params.homeDirectory && params.homeDirectory.startsWith("/") ? params.homeDirectory.slice(1) : params.homeDirectory;
    params.homeDirectory =
      params.homeDirectory && params.homeDirectory.endsWith("/") ? params.homeDirectory.slice(0, -1) : params.homeDirectory;
    const getUserData = await getRequest(Apis.GET_USER + `/${this.userId}`);
    const updateUserRes = await putRequest<AddUserType>(Apis.UPDATE_USER + `/${this.userId}`, getUserData?.eTag, params);
    if (updateUserRes?.messageStatus === null) {
      const oldDetails = this.userDetails;
      const newDetails = {
        ...oldDetails,
        email: e.detail.email,
        homeDirectory: e.detail.homeDirectory,
        role: e.detail.role,
        userType: e.detail.userType,
        businessUnit: e.detail.businessUnit,
        fullName: e.detail.fullName,
        note: e.detail.note,
        userProfileType: e.detail.userProfileType,
        authType: e.detail.authType,
      };
      this.userDetails = newDetails;
      this.apiLoading = false;
      showToast({
        message: "User details updated successfully.",
        role: "success",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
      setTimeout(() => {
        router.go("/users");
      }, 1000);
    } else if (updateUserRes.details.length > 0) {
      this.apiLoading = false;
      const errMsg = getErrorMessage(updateUserRes.details);
      showToast({
        message: errMsg,
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else {
      this.apiLoading = false;
      showToast({
        message: "Something went wrong, please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    }
  }
  async onSaveAuthClick(e) {
    this.apiLoading = true;
    const router = new Router(routerConfig);
    const params = {
      email: this.userDetails.email,
      homeDirectory: this.userDetails.homeDirectory,
      role: this.userDetails.role,
      userType: this.userDetails.userType,
      businessUnit: this.userDetails.businessUnit,
      fullName: this.userDetails.fullName,
      note: this.userDetails.note,
      userProfileType: this.userDetails.userProfileType,
      status: e.detail.userState,
      authType: e.detail.authType,
    };
    params.homeDirectory =
      params.homeDirectory && params.homeDirectory.startsWith("/") ? params.homeDirectory.slice(1) : params.homeDirectory;
    params.homeDirectory =
      params.homeDirectory && params.homeDirectory.endsWith("/") ? params.homeDirectory.slice(0, -1) : params.homeDirectory;
    const getUserData = await getRequest(Apis.GET_USER + `/${this.userId}`);
    const updateUserRes = await putRequest<AddUserType>(Apis.UPDATE_USER + `/${this.userId}`, getUserData?.eTag, params);
    if (updateUserRes?.messageStatus === null) {
      const oldDetails = this.userDetails;
      const newDetails = {
        ...oldDetails,
        status: e.detail.userState,
      };
      this.userDetails = newDetails;
      this.apiLoading = false;
      showToast({
        message: "User details updated successfully.",
        role: "success",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
      setTimeout(() => {
        router.go("/users");
      }, 1000);
    } else if (updateUserRes.details.length > 0) {
      this.apiLoading = false;
      const errMsg = getErrorMessage(updateUserRes.details);
      showToast({
        message: errMsg,
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else {
      this.apiLoading = false;
      showToast({
        message: "Something went wrong, please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    }
  }
  onInfoTabChange(e) {
    const d = { ...this.userDetails };
    this.userDetails = {
      ...d,
      email: e.detail.email,
      homeDirectory: e.detail.homeDirectory,
      role: e.detail.role,
      userType: e.detail.userType,
      businessUnit: e.detail.businessUnit,
      fullName: e.detail.fullName,
      note: e.detail.note,
      userProfileType: e.detail.userProfileType,
    };
  }
  onAuthTabChange(e) {
    const d = { ...this.userDetails };
    this.userDetails = {
      ...d,
      status: e.detail.userState,
    };
  }
  render() {
    return html`
      ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
      <div id="editUserTab">
        <h1>
          <span id="editUserTitle">${this.userId}</span>
        </h1>
        <jha-card>
          <jha-tab bordered>
            <jha-tab-item
              data-auto-id="generalInfoTab"
              ?active=${stringComparison(this.activeTab, "page1")}
              @click=${() => (this.activeTab = "page1")}>
              General Information
            </jha-tab-item>
            <jha-tab-item
              data-auto-id="userAuthTab"
              ?active=${stringComparison(this.activeTab, "page2")}
              @click=${() => (this.activeTab = "page2")}>
              User Authentication
            </jha-tab-item>
          </jha-tab>
          <div id="tabContent">
            ${stringComparison(this.activeTab, "page1")
        ? html`<user-info
                  .userDetails=${this.userDetails}
                  @onSaveInfoClick=${this.onSaveInfoChangesClick}
                  @onInfoTabChange=${this.onInfoTabChange}></user-info>`
        : html`<user-auth
                  .userDetails=${this.userDetails}
                  @onSaveAuthClick=${this.onSaveAuthClick}
                  @onAuthTabChange=${this.onAuthTabChange}></user-auth>`}
          </div>
        </jha-card>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "edit-user-tab": EditUserTabView;
  }
}
